import React, { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import ReactGA from "react-ga";
import { useState } from "react";

import Loader from "./components/_generic/Loader";
import "./App.css";
import { UserContextProvider } from "./context/UserContext";

import Header from "./components/_generic/Header";
import Footer from "./components/_generic/Footer";
import PageNotFound from "./components/Page404/Page404";

const Home = lazy(() => import("./components/Home"));
const Mica = lazy(() => import("./components/Mica"));
const Comunidades = lazy(() => import("./components/Comunidades/Home"));
const ComunidadContent = lazy(() => import("./components/Comunidades/Content"));
const Videos = lazy(() => import("./components/Videos"));
const VideosIndependent = lazy(() => import("./components/Videos/independent"));
const Webinars = lazy(() => import("./components/Webinars"));
const Leaders = lazy(() => import("./components/Leaders"));
const ToolKit = lazy(() => import("./components/ToolKit"));
const Article = lazy(() => import("./components/Article"));
const WebinarsSchedule = lazy(() => import("./components/WebinarsSchedule"));
const CoursePage = lazy(() => import("./components/CoursePage"));
const Courses = lazy(() => import("./components/Courses"));
const CoursesPayment = lazy(() => import("./components/Courses/CoursesPayment"));
const Payment = lazy(() => import("./components/Payment"));
const ComplaintsBook = lazy(() => import("./components/ComplaintsBook"));
const PrivacyPolitics = lazy(() => import("./components/PrivacyPolitics"));
const SearchPage = lazy(() => import("./components/SearchPage"));
const EscuchaActiva = lazy(() => import("./components/EscuchaActiva"));
const VideosGDHIndependent = lazy(() => import("./components/VideosGDH/independent"));
const VideosGDH = lazy(() => import("./components/VideosGDH"));
const VideosImpactDayIndependient = lazy(() => import("./components/VideosImpactDay/independent"));
const VideosImpactDay = lazy(() => import("./components/VideosImpactDay"));
const InLiderSpeaker = lazy(() => import("./components/InLiderSpeaker"));
const Podcast = lazy(() => import("./components/Podcast"));
const InclusionIBS = lazy(() => import("./components/_generic/InclusionIBS"));
const Paso01 = lazy(() => import("./components/_generic/InclusionIBS/components/inclusion/Paso01"));
const Paso02 = lazy(() => import("./components/_generic/InclusionIBS/components/inclusion/Paso02"));
const Paso03 = lazy(() => import("./components/_generic/InclusionIBS/components/inclusion/Paso03"));
const Paso04 = lazy(() => import("./components/_generic/InclusionIBS/components/inclusion/Paso04"));
const Recursos = lazy(() => import("./components/_generic/InclusionIBS/components/inclusion/Recursos"));
const HomeIBS = lazy(() => import("./components/_generic/InclusionIBS/home/HomeIBS"));
const GDHTalento = lazy(() => import("./components/_generic/InclusionIBS/components/talento/GDHTalento"));
const IdentificandoSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/identificando/identificando"));
const EvaluandoSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/evaluando/evaluando"));
const CreandoSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/creando/creando"));
const EntrevistandoSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/entrevistando/entrevistando"));
const Planeamiento = lazy(() => import("./components/_generic/InclusionIBS/components/planeamiento/planeamiento"));
const Procesos = lazy(() => import("./components/_generic/InclusionIBS/components/procesos/procesos"));
const TranslateSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/planeamiento/translate"));
const PlanSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/planeamiento/plan"));
const EvolveSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/planeamiento/evolve"));
const DiscoverySeccion = lazy(() => import("./components/_generic/InclusionIBS/components/planeamiento/discovery"));
const DiagnoseSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/planeamiento/diagnose"));
const AnexoSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/procesos/anexos"));
const QueEsSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/procesos/que-es"));
const ParaQuienSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/procesos/para-quien"));
const ConceptosClaveSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/procesos/conceptos-clave"));
const ModelosProcesosSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/procesos/modelos-de-procesos"));
const MetodologiaSeccion = lazy(() => import("./components/_generic/InclusionIBS/components/procesos/metodologia/metodologia"));
const ProblematicaMetodologia = lazy(() => import("./components/_generic/InclusionIBS/components/procesos/metodologia/problematica"));
const DiscoveryMetodologia = lazy(() => import("./components/_generic/InclusionIBS/components/procesos/metodologia/discovery"));
const ObjetivoMetodologia = lazy(() => import("./components/_generic/InclusionIBS/components/procesos/metodologia/objetivo"));
const EquipoMetodologia = lazy(() => import("./components/_generic/InclusionIBS/components/procesos/metodologia/equipo"));
const CronogramaMetodologia = lazy(() => import("./components/_generic/InclusionIBS/components/procesos/metodologia/cronograma"));
const ProyectoMetodologia = lazy(() => import("./components/_generic/InclusionIBS/components/procesos/metodologia/proyecto"));
const DiversidadIntro = lazy(() => import("./components/_generic/InclusionIBS/components/diversidad/DiversidadIntro"));
const FreeCourses = lazy(() => import("./components/FreeCourses"));
const ToolsIA = lazy(() => import("./components/ToolsIA"));
const LearnUp = lazy(() => import("./components/LearnUPs"));
const Impacto = lazy(() => import("./components/Impacto"));
const Parlante = lazy(() => import("./components/Parlante"));
const CursosMinisterio = lazy(() => import("./components/CoursesMinisterio"));
/* const VideosUdemy = lazy(() => import("./components/VideosUdemy"));*/
const VideosAniversario = lazy(() => import("./components/VideosAniversario"));


const App = ({ first_name }) => {
  const [is404, setIs404] = useState(false);

  useEffect(() => {
    let GA_ID =
      window.location.origin === "https://entrenate.ucic.pe"
        ? "UA-153617102-2"
        : "UA-153617102-4";
    ReactGA.initialize(GA_ID, {
      debug: false,
      titleCase: false,
    });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <UserContextProvider>
      <BrowserRouter>
        <Suspense fallback={<Loader />}>

          {!is404 && <Header />}

          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/home" component={Home} />
            <Route exact path="/videos" component={Videos} />
            <Route exact path="/videos/:slug" component={VideosIndependent} />
            <Route exact path="/simposium" component={VideosGDH} />
            <Route exact path="/simposium2020/:slug" component={VideosGDHIndependent} />
            <Route exact path="/simposium2021/:slug" component={VideosGDHIndependent} />
            <Route exact path="/simposium2022/:slug" component={VideosGDHIndependent} />
            <Route exact path="/simposium2023/:slug" component={VideosGDHIndependent} />
            <Route exact path="/impactday" component={VideosImpactDay} />
            <Route exact path="/impactday/:slug" component={VideosImpactDayIndependient} />
            <Route exact path="/fest-series/:slug" component={Webinars} />
            <Route exact path="/voces-intercorp/:slug" component={Webinars} />
            <Route exact path="/webinars/link-:slug" component={Webinars} />
            <Route exact path="/webinars/:slug" component={Webinars} />
            <Route exact path="/InLiderSpeaker/:slug" component={InLiderSpeaker} />
            <Route exact path="/webinars-schedule" component={WebinarsSchedule} />
            <Route exact path="/cursos/:slug/payment" component={CoursesPayment} />
            <Route exact path="/cursos/:slug" component={Courses} />
            <Route exact path="/cursos" component={CoursePage} />
            <Route exact path="/payment/:slug" component={Payment} />
            <Route exact path="/leaders/:slug" component={Leaders} />
            <Route exact path="/toolkit/:id" component={ToolKit} />
            <Route exact path="/article/:slug" component={Article} />
            <Route exact path="/escucha-activa/:slug" component={EscuchaActiva} />
            <Route exact path="/libro-de-reclamaciones" component={ComplaintsBook} />
            <Route exact path="/politica-de-privacidad" component={PrivacyPolitics} />
            <Route exact path="/search/:slug" component={SearchPage} />
            <Route exact path="/programas2025" component={Mica} />
            <Route exact path="/cursos-gratuitos" component={FreeCourses} />
            <Route exact path="/cursos-gratuitos/:slug" component={FreeCourses} />
            <Route exact path="/impacto" component={Impacto} />
            <Route exact path="/impacto/:slug" component={Impacto} />
            <Route exact path="/herramientas-ai" component={ToolsIA} />
            <Route exact path="/herramientas-ai/:slug" component={ToolsIA} />
            <Route exact path="/comunidades" component={Comunidades} />
            <Route exact path="/comunidades/:slug" component={ComunidadContent} />
            <Route exact path="/podcast/:slug" component={Podcast} />
            <Route exact path="/gdh/inclusion/intro" component={InclusionIBS} />
            <Route exact path="/homeibs" component={HomeIBS} />
            <Route exact path="/gdh/inclusion/minimiza-sesgos" component={Paso01} />
            <Route exact path="/gdh/inclusion/promueve-seguridad-psicologica" component={Paso02} />
            <Route exact path="/gdh/inclusion/tolerancia-cero-acoso" component={Paso03} />
            <Route exact path="/gdh/inclusion/acciones-inclusivas" component={Paso04} />
            <Route exact path="/gdh/inclusion/recursos-sugeridos" component={Recursos} />
            <Route exact path="/gdh/talento" component={GDHTalento} />
            <Route exact path="/gdh/diversidad" component={DiversidadIntro} />
            <Route exact path="/gdh/identificando" component={IdentificandoSeccion} />
            <Route exact path="/gdh/evaluando" component={EvaluandoSeccion} />
            <Route exact path="/gdh/creando" component={CreandoSeccion} />
            <Route exact path="/gdh/entrevistando" component={EntrevistandoSeccion} />
            <Route exact path="/gdh/planeamiento" component={Planeamiento} />
            <Route exact path="/gdh/procesos" component={Procesos} />
            <Route exact path="/gdh/planeamiento/translate" component={TranslateSeccion} />
            <Route exact path="/gdh/planeamiento/plan" component={PlanSeccion} />
            <Route exact path="/gdh/planeamiento/evolve" component={EvolveSeccion} />
            <Route exact path="/gdh/planeamiento/discovery" component={DiscoverySeccion} />
            <Route exact path="/gdh/planeamiento/diagnose" component={DiagnoseSeccion} />
            <Route exact path="/gdh/procesos/anexos" component={AnexoSeccion} />
            <Route exact path="/gdh/procesos/que-es" component={QueEsSeccion} />
            <Route exact path="/gdh/procesos/para-quien" component={ParaQuienSeccion} />
            <Route exact path="/gdh/procesos/conceptos-clave" component={ConceptosClaveSeccion} />
            <Route exact path="/gdh/procesos/modelos-de-procesos" component={ModelosProcesosSeccion} />
            <Route exact path="/gdh/procesos/metodologia" component={MetodologiaSeccion} />
            <Route exact path="/gdh/procesos/metodologia/problematica" component={ProblematicaMetodologia} />
            <Route exact path="/gdh/procesos/metodologia/discovery" component={DiscoveryMetodologia} />
            <Route exact path="/gdh/procesos/metodologia/objetivo" component={ObjetivoMetodologia} />
            <Route exact path="/gdh/procesos/metodologia/equipo" component={EquipoMetodologia} />
            <Route exact path="/gdh/procesos/metodologia/cronograma" component={CronogramaMetodologia} />
            <Route exact path="/gdh/procesos/metodologia/proyecto" component={ProyectoMetodologia} />
            <Route exact path="/learn-up" component={LearnUp} />
            <Route exact path="/learn-up/:slug" component={LearnUp} /> 
            <Route exact path="/parlante" component={Parlante} />
            <Route exact path="/parlante/:slug" component={Parlante} />           
            <Route exact path="/cursos-ministerio" component={CursosMinisterio} />
            <Route exact path="/cursos-ministerio/:slug" component={CursosMinisterio} />
            {/* <Route exact path="/videosUdemy/:id" component={VideosUdemy} /> */}
            <Route exact path="/aniversario_ucic/:slug" component={VideosAniversario} />
            <Route component={PageNotFound} />
          </Switch>

          {!is404 && <Footer />}

        </Suspense>
      </BrowserRouter>
    </UserContextProvider>
  );
};

export default App;
